import { useRepositoryQuery } from '@mews-commander/data-access';

export const useContractFieldsQuery = ({ externalTemplateId }: { externalTemplateId?: string }) =>
    useRepositoryQuery(
        'reservationContractExternalTemplates',
        'getAllFields',
        {
            externalTemplateId: externalTemplateId as string,
        },
        {
            enabled: externalTemplateId != null,
        }
    );
